export default "https://cdn-static.gokick.com/assets/643951300d065933ed58add7baf5b7b086396c88/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";